import React from 'react';
import { set } from 'lodash/fp';
import { sortBy, } from 'lodash';
import { toast } from 'react-toastify';
import { format as formatDate, } from 'date-fns';

import firebase from '../../firebase';
import { colors, } from '../../shared/config';
import AdminPage from '../hocs/AdminPage';
import ModelFormModal from '../modals/ModelFormModal';
import TenantLink from '../TenantLink';
import useCollectionFetch from '../hooks/useCollectionFetch';

const db = firebase.firestore();

export default AdminPage(function AdminLectureTypes (props) {
  const { user } = props;
  const publicItems = useCollectionFetch(db.collection('publicItems').orderBy('paymentTriedAt', 'desc'));

  return (
    <div>
      <div className="admin-lectureTypes container py-5 position-relative">
        <div className="d-flex justify-content-center mb-3">
          <h4>注文決済状況</h4>
        </div>
        <div className="d-flex justify-content-end mb-3 gap-3">
          <div>
            総件数: {publicItems.length.toLocaleString()}
          </div>
          <div>
            決済試行件数: {publicItems.filter(_ => _.hasTriedPayment).length.toLocaleString()}
          </div>
          <div>
            受注確定件数: {publicItems.filter(_ => _.hasCreatedOrder).length.toLocaleString()}
          </div>
        </div>
        <div>
          <table className="table">
            <thead className="thead-light text-center">
              <tr>
                <th></th>
                <th>決済試行日時</th>
                <th>決済試行回数</th>
                <th>受注確定日時</th>
                <th>受注確定回数</th>
              </tr>
            </thead>
            <tbody>
              {
                publicItems.map((publicItem) => {
                  const { id, paymentTriedAt, countOfTry, orderCreatedAt, countOfComplete, } = publicItem;

                  return (
                    <tr key={id}>
                      <td>
                        <TenantLink to={`/admin/users/${id}`}>{id}</TenantLink>
                      </td>
                      <td>
                        {formatDate(paymentTriedAt.toDate(), 'yyyy/MM/dd HH:mm:ss')}
                      </td>
                      <td>
                        {countOfTry?.toLocaleString()}
                      </td>
                      <td>
                        {orderCreatedAt && formatDate(orderCreatedAt.toDate(), 'yyyy/MM/dd HH:mm:ss')}
                      </td>
                      <td>
                        {countOfComplete?.toLocaleString()}
                      </td>
                    </tr>
                  );
                })
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
});

